import styled from "styled-components";

const Whole = styled.div`
    height : 100vh;
`

const Intro = () => {
    return(
        <Whole>
            이건 메인화면
        </Whole>
    );
};

export default Intro;